// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2zmOT","inputWrap":"Table_inputWrap__1rPAu","col":"Table_col__35876","bmiTooltip":"Table_bmiTooltip__2MTBE"};